import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { FirstRun } from "@/features/athlete";

/**
 * FIRST RUN — the five questions, OUTSIDE `_app` and therefore outside the tab bar.
 *
 * ⚠️ THAT PLACEMENT IS THE DECISION. The design system says navigation is present on
 * top-level screens and absent inside flows, and this is unambiguously a flow: it has a back
 * arrow, a cross that abandons it and a progress bar, all of which mean nothing beside four
 * tabs offering to leave. `_app` owns the tab bar, so a route under it would inherit one.
 *
 * The guard is `_app`'s, restated rather than shared: it redirects on `anonymous` and NEVER
 * on `unknown`, because on launch the session token is still being read out of the Keychain
 * and treating not-yet-known as signed-out bounces every returning athlete to sign-in for a
 * frame.
 */
export const Route = createFileRoute("/first-run")({
  beforeLoad: ({ context }) => {
    if (context.auth.status === "anonymous") throw redirect({ to: "/sign-in" });
  },
  component: FirstRunScreen,
});

function FirstRunScreen() {
  const navigate = useNavigate();

  /**
   * LEAVING ALWAYS LANDS ON THE DECK, whether the flow was finished or abandoned on step one.
   * Nothing is gated behind completion — an athlete who walks away is planned for at the
   * engine's floor, which is a legitimate state that produces valid sessions.
   */
  return <FirstRun onLeave={() => void navigate({ to: "/" })} />;
}
